export const ADMIN_DASHBOARD_ROLE_ID = 1;
export const ADMIN_BUSINESS_ROLE_IDS: number[] = [2, 3, 4];
export const ADMIN_ALLOWED_ROLE_IDS = [
  ADMIN_DASHBOARD_ROLE_ID,
  ...ADMIN_BUSINESS_ROLE_IDS,
];

export const filterAdminRoleIds = (roleIds: number[] = []) =>
  Array.from(
    new Set(roleIds.filter((roleId) => ADMIN_ALLOWED_ROLE_IDS.includes(roleId)))
  );
